import { SaveButton, Toolbar } from 'react-admin'

export const ToolBarWithoutDelete = () => {
   return (
      <Toolbar>
         <SaveButton/>
      </Toolbar>
   )
}